<template>
  <nav
    class="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between navbar-expand-lg bg-red-600"
  >
    <div
      class="w-full mx-auto flex flex-wrap items-center justify-between"
    >
      <div
        class="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start bg-white"
      >
        <a
          class="lg:text-white lg:hover:text-gray-300 text-gray-800 py-4 lg:py-2 flex items-center text-xs"
          href="#inicio"
        >
          <img src="../assets/img/g3pro.png" width="350px" alt="G3Ingenieria"
        /></a>
        <button
          class="cursor-pointer text-3xl leading-none px-10 py-1 border border-solid border-transparent rounded bg-red-600 lg:bg-transparent block lg:hidden outline-none focus:outline-none"
          type="button"
          v-on:click="toggleNavbar()"
        >
          <i class="text-white fas fa-bars"></i>
        </button>
      </div>
      <div
        class="lg:flex flex-grow items-center bg-white lg:bg-transparent lg:shadow-none"
        v-bind:class="{ hidden: !showMenu, block: showMenu }"
      >
        <ul class="flex flex-col lg:flex-row list-none lg:ml-auto">
          <li class="items-center">
            <a
              class="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs"
              href="#inicio" v-on:click="cerrarNavBar()"
            >
              <i
                class="lg:text-gray-300 text-gray-500 fas fa-home text-xl leading-lg"
              ></i>
              <span class="inline-block text-xl ml-5 lg:ml-2">Inicio</span></a
            >
          </li>
          <li class="items-center">
            <a
              class="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs"
              href="#nosotros" v-on:click="cerrarNavBar()"
            >
              <i
                class="lg:text-gray-300 text-gray-500 fas fa-users text-xl leading-lg"
              ></i>
              <span class="inline-block text-xl ml-5 lg:ml-2">Nosotros</span></a
            >
          </li>
          <li class="items-center">
            <a
              class="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs"
              href="#servicios" v-on:click="cerrarNavBar()"
              ><i
                class="lg:text-gray-300 text-gray-500 fas fa-tools text-xl leading-lg"
              ></i
              ><span class="inline-block text-xl ml-5 lg:ml-2">Servicios</span></a
            >
          </li>
          <li class="items-center">
            <a
              class="lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs"
              href="#clientes" v-on:click="cerrarNavBar()"
              ><i
                class="lg:text-gray-300 text-gray-500 fas fa-user-tie text-2xl leading-lg"
              ></i
              ><span class="inline-block text-xl ml-5 lg:ml-2">Clientes</span></a
            >
          </li>
          <li class="items-center">
            <a
              class="mr-5 lg:text-white lg:hover:text-gray-300 text-gray-800 px-3 py-4 lg:py-2 flex items-center text-xs"
              href="#contacto" 
              v-on:click="cerrarNavBar()"
              ><i
                class="lg:text-gray-300 text-gray-500 fas fa-mail-bulk text-2xl leading-lg"
              ></i
              ><span class="inline-block text-xl ml-5 lg:ml-2">Contacto</span></a
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style>
/*
  nav.scrolled {
    background-color: #e53e3e;
  }
  nav div div.scrolled2 {
    background-color: white;
  }
  */
  /* Poner esta clase en el div a Scroll */
  /* :class="{ 'scrolled2': !view.atTopOfPage }" */
  /* Poner esta clase en el div a Scroll */
  /* :class="{ 'scrolled': !view.atTopOfPage }" */
</style>

<script>
export default {
  data() {
    return {
      /*
    //para cambiar color en scroll
        view: {
            atTopOfPage: true
        },
        */
      showMenu: false,
    };
  },
  /*
  //para cambiar color en scroll
  beforeMount () {
    window.addEventListener('scroll', this.handleScroll);
  },
  */
  methods: {
    /*
    //para cambiar color en scroll
    handleScroll(){
        if(window.pageYOffset > 0){
            if(this.view.atTopOfPage) {
              this.view.atTopOfPage = false;
            }
        }else{
            if(!this.view.atTopOfPage) {
              this.view.atTopOfPage = true;
            } 
        }
    }*/
    toggleNavbar: function() {
      this.showMenu = !this.showMenu;
    },
    cerrarNavBar: function() {
      this.showMenu = false;
    }
  },
};
</script>
